import ReadFileView from './ReadFileViewContainer';
export default ReadFileView;
